module.exports = __webpack_public_path__ + "img/pop_wallet_logo_exodus@2x.94c7bf22.png";